var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "graph as-flex main-center cross-center" },
    [
      _vm.has_result
        ? [
            _c("canvas", {
              ref: "chart",
              staticClass: "graph-chart",
              attrs: { id: "myChart" },
            }),
          ]
        : [
            _c(
              "div",
              {
                staticClass:
                  "graph-chart as-flex main-center cross-center f-3 fc-gray-2",
              },
              [_vm._v("影片类型感知可根据需求做定制挖掘，在此暂不呈现")]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }